import H5PPlayerWrapper from "./H5PPlayerWrapper";

export default H5PPlayerWrapper;
